'use strict';

var _ = require('lodash');
var AdvancedHepGridDirective = function AdvancedHepGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/advanced-hep-grid.html'),
    controller: 'AdvancedHepGridController',
    link: function link($scope, element) {
      function getColumns(fieldId) {
        var allColumns = $scope.settings.columns;
        var column = _.find(allColumns, ['field', fieldId]);
        if (!column) {
          _.forEach(allColumns, function (columnGroup) {
            if (!column) {
              column = _.find(columnGroup.columns, ['field', fieldId]);
            }
          });
        }
        return column.columnMetadata.columns;
      }
      function getSubTypeLabel(fieldId) {
        var allFields = $scope.settings.fields;
        var field = _.find(allFields, ['name', fieldId]);
        return _.isEmpty(field) ? undefined : field.subTypeLabel;
      }
      $scope.$on('grid:icon-click', function (event, data) {
        $scope.configurationModalData.columns = getColumns(data.fieldId);
        $scope.configurationModalData.eventData = data;
        $scope.subTypeLabel = getSubTypeLabel(data.fieldId);
        $scope.configurationModalData.isModalShown = true;
      });
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
      $scope.$on('grid:cellValueChanged', function (event, change, gridId) {
        if ($scope.tripDirectionOneWay(gridId, change)) {
          $scope.updateLOSFields(change.rowindex, gridId);
        }
      });
    }
  };
};
AdvancedHepGridDirective.$inject = [];
module.exports = AdvancedHepGridDirective;